import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Resource_Search, Resource } from '../model/resource-actions';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../services/filter-data.service';
import { SelectListItem } from '../lib/select/select-property';
import { AppService } from '../services/app.service';
import { ReturnClass } from 'projects/Shared-Lib/model/search-result';
import { TableSetting } from 'projects/Shared-Lib/component/table/table-class';

@Component({
  selector: 'app-resource-actions',
  templateUrl: './resource-actions.component.html',
  styleUrls: ['./resource-actions.component.css']
})
export class ResourceActionsComponent {
  @ViewChild('acc') acc: NgbAccordionItem; //link to ngAfterViewInit().
  ControllerName: string = 'ResourceActions';

  model: Resource_Search;
  displayedColumns: string[] = ['resourceid', 'resourcename', 'enabled'];

  //傳入 DataTable 資料之變數
  TableData: ReturnClass;
  currentRoute: string;
  sampleMenu: any[];

  userPermission: any;
  TableSetting: TableSetting;

  CanCreate: boolean = true;
  CanDelete: boolean = true;
  CanEdit: boolean = true;

  constructor(private dataSer: DataService,
    private DlgService: DialogService, private app: AppService,
    private router: Router, private filterService: FilterDataService) {
    this.model = new Resource_Search();

    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'ResourceID';
    this.TableSetting.ItemTitle = (element: Resource) => {
      return `${element.ResourceName}`;
    };
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'ResourceName', header: 'Resource Name', cell: (element: Resource) => `${element.ResourceName}` },
      { columnDef: 'IsEnabled', header: 'IsEnabled', cell: (element: Resource) => `${element.IsEnabled ? "Y" : "N"}` },
    ];

    this.userPermission = this.app.currentResource.subscribe(data => {
      this.TableSetting.CanUpdate = data.CanUpdate;
      this.TableSetting.CanDelete = data.CanDelete;
    })

    this.dataSer.getData(this.ControllerName + '/init', null,
      (data) => {
        this.model.ddlResource = new Array<SelectListItem>();
        let i = 1;
        data.Resources.forEach(it => {
          let o: SelectListItem = {
            value: it.ResourceID,
            text: it.ResourceName,
            index: i++
          };
          this.model.ddlResource.push(o);
        });
        const firstItem: SelectListItem = { value: '0', text: 'All the below', index: 0 };
        this.model.ddlResource.unshift(firstItem);
      });
  }

  ngOnInit() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  ngAfterViewInit() {
    // The ngb-accordion object can only be accessed after the page has initialized: setTimeout(() => this.acc.expandAll(), 0);
  }

  Search() {
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.model.filter = LasttimeSearchInfo.Filter;
      }
    }

    this.filterService.ChangeSearchInfo(this.currentRoute, this.model.filter);

    this.dataSer.getData(this.ControllerName + '/List', this.model.filter, (res) => {
      this.TableData = {
        draw: this.model.filter.PageIndex,
        pagingSize: this.model.filter.PageSize,
        recordsTotal: res.TotalCount,
        recordsFiltered: res.TotalCount,
        data: res.DataList
      };
    }, (res) => {

    }, (res) => {
      setTimeout(() => this.app.SetLoadingState(false), 0);
    })
  }

  //call from child component : data-source-table -> change page size function
  onChangePageInfo(PageInfo: any) {
    this.model.filter.PageSize = PageInfo.PageSize;
    this.model.filter.PageIndex = PageInfo.CurrentPage;

    this.Search();
  }

  onChangeTableInfo(TableInfo: any) {
    this.model.filter.SortBy = TableInfo.SortBy;
    this.model.filter.IsAsc = TableInfo.IsAsc;

    this.Search();
  }

  Delete(DeleteItem: any) {
    console.log('delete resource id', DeleteItem)
    this.app.SetLoadingState(true);
    this.dataSer.DeleteData(`${this.ControllerName}/${DeleteItem.ResourceID}`, null,
      (res) => {
        console.log(res);
        this.Search();
      },
      (res) => {
        let result = this.DlgService.ErrorInformation(res.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      },
      () => {
        this.app.SetLoadingState(false);
      }
    );
  }
}
